import {CommonModule} from "@angular/common";
import {Component, inject, signal, ViewChild} from "@angular/core";
import {ModalComponent} from "../modal.component";
import {EditorComponent} from "../../editor/editor.component";
import {ModalService} from "src/app/shared/data-access/modal.service";
import {
  SaveCancelButtonsComponent
} from "../../../../features/admin/components/save-cancel-buttons/save-cancel-buttons.component";

@Component({
  selector: "app-editor-modal",
  templateUrl: "./editor-modal.component.html",
  styleUrls: ["./editor-modal.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    EditorComponent,
    SaveCancelButtonsComponent,
  ],
})
export class EditorModalComponent {
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  modelService = inject(ModalService);
  content = signal<string>("");
  gptResponse = signal<string>("");

  onGptResponse(response: string) {
    this.gptResponse.set(response);
  }

  acceptGptSolution() {
    this.editorComponent.editorInstance().setData(this.gptResponse());
    this.gptResponse.set("");
  }

  openModal() {
    this.modelService.openModal("editor-ki-modal");
  }

  closeModal() {
    this.modelService.closeModal("editor-ki-modal");
  }

}
